require('./hirePackOpenYoungStep2.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const { HireContactDataForm } = require('components/hireContactDataForm/hireContactDataForm');
const { OpenYoungPersonalDataForm } = require('components/openYoungPersonalDataForm/openYoungPersonalDataForm');
const { OpenYoungTaxDataForm } = require('components/openYoungTaxDataForm/openYoungTaxDataForm');
const { OpenYoungTutorTypeSelect } = require('components/openYoungTutorTypeSelect/openYoungTutorTypeSelect');

// @ constants
const {
    SECOND_STEP,
} = require('constants/index');

class HirePackOpenYoungStep2 extends React.Component {
    buildDisclaimerPersonalInfo() {
        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-disclaimerPersonalInfo_hirePackOpenYoungLinkURL');

        return (
            <OKMessage
                key="5"
                type="informative"
            >
                <FormattedText value="disclaimerPersonalInfo-disclaimerPersonalInfo _hirePackOpenYoungMsg" />
                &nbsp;
                <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                    <FormattedText value="disclaimerPersonalInfo-disclaimerPersonalInfo_hirePackOpenYoungLinkText" />
                </OKLink>
            </OKMessage>
        );
    }

    buildContent(titleTranslationKey, content) {
        return (
            <div className="hire-pack-open-young-step-two__content">
                <FormattedText
                    className="hire-pack-open-young-step-two__content-header"
                    value={titleTranslationKey}
                />
                {content}
            </div>
        )
    }

    render() {
        const {
            handleTutorCheckboxChange,
            immHirePackOpenYoung,
            immHireContactData,
            immOpenYoungPersonalData,
            immOpenYoungTaxData,
            immOpenYoungTutorType,
        } = this.props;
        const immStep2 = immHirePackOpenYoung.getIn(['steps', SECOND_STEP]);
        const tutorLabel = formatText('hirePackOpenYoung-hirePackOpenYoung_declaration');
        const tutorErrorMessage = formatText('hirePackOpenYoung-hirePackOpenYoung_declarationError');
        const tutorCheckbox = immStep2.get('tutorCheckbox');
        const tutorCheckboxErrorState = tutorCheckbox.get('isDirty') && !tutorCheckbox.get('isValid');
        let forms = [];

        if (tutorCheckbox.get('value')) {
            forms = [
                this.buildContent('hirePackOpenYoung-hirePackOpenYoung_relationshipSelectTitle', (
                    <OpenYoungTutorTypeSelect
                        immOpenYoungTutorType={immOpenYoungTutorType}
                    />
                ), 1),
                this.buildContent('hirePackOpenYoung-hirePackOpenYoung_personalDataFormTitle', (
                    <OpenYoungPersonalDataForm
                        immOpenYoungPersonalData={immOpenYoungPersonalData}
                        isOYPack={true}
                        validateDocument={true}
                    />
                ), 2),
                this.buildContent('hirePackOpenYoung-hirePackOpenYoung_contactDataFormTitle', (
                    <HireContactDataForm
                        immHireContactData={immHireContactData}
                        instanceId="hirePackOpenYoungContact"
                    />
                ), 3),
                this.buildContent('hirePackOpenYoung-hirePackOpenYoung_taxDataFormTitle', (
                    <OpenYoungTaxDataForm
                        immOpenYoungTaxData={immOpenYoungTaxData}
                    />
                ), 4),
                this.buildDisclaimerPersonalInfo()
            ]
        }

        return (
            <article className="hire-pack-open-young-step-two">
                <div className="row hire-pack-open-young-step-two__declaration-section">
                    <OKCheckbox
                        idName="checkbox-tutor"
                        value={tutorCheckbox.get('value')}
                        onChange={handleTutorCheckboxChange}
                        label={tutorLabel}
                        errorState={tutorCheckboxErrorState}
                        errorMessage={tutorErrorMessage}
                        extraClass="col-xs-12"
                    />
                </div>
                {forms}
            </article>
        );
    }
}

HirePackOpenYoungStep2.propTypes = {
    handleTutorCheckboxChange: PropTypes.func.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHirePackOpenYoung: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immOpenYoungTaxData: PropTypes.object.isRequired,
    immOpenYoungTutorType: PropTypes.object.isRequired,
    validate: PropTypes.func.isRequired,
};

module.exports = HirePackOpenYoungStep2;
